import { useEffect, useState } from "react";

import Header from "./components/layout/Header/Header";
import Footer from "./components/layout/Footer/Footer";

import ProductGrid from "./components/product/ProductGrid/ProductGrid";
import ProductModal from "./components/product/ProductModal/ProductModal";

import { getProducts } from "./services/catalogService";

import styles from "./App.module.css";

function App() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    async function loadProducts() {
      try {
        const data = await getProducts();
        setProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    loadProducts();
  }, []);

  function handleProductClick(product) {
    setSelectedProduct(product);
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
    setSelectedProduct(null);
  }

  if (loading) {
    return <p>Carregando catálogo...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className={styles.app}>
      <Header />

      <main className={styles.main}>
        <section className={styles.hero}>
          <p>Doces • Salgados • Encomendas</p>
        </section>

        <section className={styles.catalog}>
          <h2>Nossas Delicices</h2>

          <ProductGrid
            products={products}
            onProductClick={handleProductClick}
          />
        </section>
      </main>

      <Footer />

      <ProductModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        product={selectedProduct}
      />
    </div>
  );
}

export default App;